import React, { useState, useEffect } from "react";

const Timer = () => {
  // Ścieżka do pliku MP3
  const audio = new Audio("https://mojapamiec.pl/acdc.mp3");

  const [isActivated, setIsActivated] = useState(false);

  // Docelowy czas (np. 14:30)
  const targetHour = 11;
  const targetMinute = 17;

  const checkTimeAndPlaySound = () => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    // Sprawdzamy, czy bieżący czas to docelowy czas
    if (currentHour === targetHour && currentMinute === targetMinute) {
      audio.play().catch((error) => {
        console.error("Błąd odtwarzania dźwięku:", error);
      });
    }
  };

  useEffect(() => {
    if (isActivated) {
      const interval = setInterval(checkTimeAndPlaySound, 1000);
      return () => clearInterval(interval);
    }
  }, [isActivated]);

  return (
    <div>
      <h2>Reminder Sound</h2>
      <p>
        Odtworzy się o godzinie {targetHour}:{targetMinute}.
      </p>
      {!isActivated && (
        <button onClick={() => setIsActivated(true)}>Aktywuj dźwięk</button>
      )}
    </div>
  );
};

export default Timer;
